import type { ToneOverlay } from "../index.js";

// Voz "dark" en castellano: mala leche, fatalismo y sorna castiza — humor propio, no una
// traducción del inglés. Opcional; la voz seria sigue siendo la predeterminada. Las líneas
// con variantes rotan cada dos horas (TONE_ROTATE_MS). Cada variante conserva los
// {marcadores} de la base (lo verifica tone-guardrail.test.ts).
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} cerca. Lo que nos faltaba.",
    "{hazard} cerca. Pues ya estamos.",
    "{hazard} cerca. Esto es España, tú aguanta.",
    "{hazard} cerca. Avisa al grupo de WhatsApp.",
    "{hazard} cerca. Qué bien, oye.",
  ],
  "alert.toast.escalation": [
    "El {hazard} ha ido a peor. Cómo no.",
    "El {hazard} sube. Pues nada, a peor.",
    "El {hazard} a más. Ni de coña mejora solo.",
    "El {hazard} se viene arriba. Qué ilusión.",
  ],
  "alert.toast.inPath": [
    "El {hazard} viene a por ti. Personalmente. Corre.",
    "El {hazard} te ha cogido cariño. Huye.",
    "El {hazard} va directo a ti. Hoy no, gracias.",
    "El {hazard} con nombre y apellidos: el tuyo. Largo.",
  ],
  "alert.toast.allClear": [
    "Sigues vivo cerca de {place}. Algo es algo.",
    "{place} no te ha pillado. Por esta vez.",
    "Has sobrevivido a {place}. Apúntatelo.",
    "Todo en calma cerca de {place}. Hasta la próxima.",
  ],
  "alert.toast.tap": [
    "Toca para el plan de no palmarla.",
    "Toca, que aquí está cómo seguir vivo.",
    "Toca. Las instrucciones de respirar, dentro.",
  ],
  "alert.takeover.title": [
    "{hazard} — hoy te toca ser protagonista. Venga.",
    "{hazard} — la parte de correr de la peli. Corre.",
    "{hazard} — actúa ya, las quejas luego.",
  ],
  "alert.takeover.details": "Los detalles, con su morbo",
  "alert.takeover.dismiss": "Sobrevivido, cerrar",
  "now.status.allClear": [
    "Sigues aquí. Mira tú.",
    "Aún respirando. Toma ya.",
    "Estadísticamente, bien.",
    "Tranquilo. Sospechosamente tranquilo.",
    "Vivo y aburrido. Lo ideal.",
    "Sin novedad en el frente.",
    "Ni fu ni fa. Perfecto.",
  ],
  "now.status.stayAware": [
    "Ojo, que las carga el diablo.",
    "No te fíes ni de tu sombra.",
    "Un ojo abierto, por si acaso.",
    "Esta es la parte tranquila. Disfruta.",
    "No te confíes, anda.",
    "Tú vigila, no vaya a ser.",
  ],
  "now.status.sub.allClear": [
    "Nada que quiera matarte en el radio. Milagro.",
    "Sin peligros cerca. Tú desconfía igual.",
    "El radio, limpio. De momento.",
    "Nada en el radar. A ver cuánto dura.",
    "Todo en calma. Demasiada calma.",
    "Nada a la vista. El universo está a otra cosa.",
  ],
  "now.activity.empty": [
    "Sospechosamente tranquilo, oye.",
    "Nada. Casi de mal gusto.",
    "Esto está más muerto que el agosto.",
    "Ni un alma. Grillos.",
    "Cero noticias. Fingimos que es bueno.",
    "Silencio. Mal rollo, pero silencio.",
  ],
  "onboarding.promise.tagline": "Vecinos manteniendo a vecinos sobre el suelo.",
  "onboarding.promise.continue": "Sobrevivamos esto",
  "onboarding.home.browse": "Solo curioseando el apocalipsis",
  "you.voice.intro": "Elige tu variedad de malas noticias.",
};
